<template>
  <div v-if="detail">
    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">负债概要(未结清)</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">类型</div>
        <div class="datacell">信用卡</div>
        <div class="datacell">账户数</div>
        <div class="datacell">授信额度(元)</div>
        <div class="datacell">余额(元)</div>
        <div class="datacell">使用率(%)</div>
      </div>
      <div class="dataitem">
        <div class="datacell">贷款</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.loan.institutionCount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.loan.count }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.loan.grant_amount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.loan.balance_amount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.loan.usage_rate }}%</div>
      </div>
      <div class="dataitem">
        <div class="datacell">信用卡</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.debitCard.institutionCount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.debitCard.count }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.debitCard.grant_amount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.debitCard.balance_amount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.debitCard.usage_rate }}%</div>
      </div>
      <div class="dataitem">
        <div class="datacell">合计</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.total.institutionCount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.total.count }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.total.grant_amount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.total.balance_amount }}</div>
        <div class="datacell">{{ detail.debtSummaryUnsettled.total.usage_rate }}%</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">相关还款(未结清)概要</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">相关还款责任</div>
        <div class="datacell">账户数</div>
        <div class="datacell">责任金额</div>
        <div class="datacell">余额</div>
      </div>
      <div class="dataitem">
        <div class="datacell">为个人</div>
        <div class="datacell">{{ detail.relatedRepaymentSummary.forIndividual.account_num }}</div>
        <div class="datacell">{{ detail.relatedRepaymentSummary.forIndividual.grant_amount }}</div>
        <div class="datacell">{{ detail.relatedRepaymentSummary.forIndividual.balance_amount }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">为企业</div>
        <div class="datacell">{{ detail.relatedRepaymentSummary.forEnterprise.account_num }}</div>
        <div class="datacell">{{ detail.relatedRepaymentSummary.forEnterprise.grant_amount }}</div>
        <div class="datacell">{{ detail.relatedRepaymentSummary.forEnterprise.balance_amount }}</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">特殊业务(未结算)概要</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">贷款</div>
        <div class="datacell">机构数</div>
        <div class="datacell">账户数</div>
        <div class="datacell">授信额度(元)</div>
        <div class="datacell">余额(元)</div>
      </div>
      <div class="dataitem">
        <div class="datacell">住房按揭</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.buyHouse.institutionCount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.buyHouse.count }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.buyHouse.grant_amount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.buyHouse.balance_amount }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">经营性贷款</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalBusiness.institutionCount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalBusiness.count }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalBusiness.grant_amount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalBusiness.balance_amount }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">消费性贷款</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalConsumption.institutionCount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalConsumption.count }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalConsumption.grant_amount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.personalConsumption.balance_amount }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">小贷公司放款</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.smallLoan.institutionCount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.smallLoan.count }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.smallLoan.grant_amount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.smallLoan.balance_amount }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">消费金融公司房贷</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.consumerFinance.institutionCount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.consumerFinance.count }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.consumerFinance.grant_amount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.consumerFinance.balance_amount }}</div>
      </div>
      <div class="dataitem">
        <div class="datacell">信用卡大额分期</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.largeInstallment.institutionCount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.largeInstallment.count }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.largeInstallment.grant_amount }}</div>
        <div class="datacell">{{ detail.specialBusinessSummaryUnsettled.largeInstallment.balance_amount }}</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">贷款明细(未结清及逾期账户)</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">管理机构</div>
        <div class="datacell">额度</div>
        <div class="datacell">余额</div>
        <div class="datacell">业务类型</div>
        <div class="datacell">发放日期</div>
        <div class="datacell">状态</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail.loanDetails">
        <div class="datacell">{{ item.bank_name }}</div>
        <div class="datacell">{{ item.grant_amount }}</div>
        <div class="datacell">{{ item.balance_amount }}</div>
        <div class="datacell">{{ item.loan_type ? item.loan_type : '' }}</div>
        <div class="datacell">{{ item.show_grant_date ? item.show_grant_date : '' }}</div>
        <div class="datacell">{{ item.show_current_status ? item.show_current_status : '' }}</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">信用卡明细</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">银行</div>
        <div class="datacell">额度</div>
        <div class="datacell">余额</div>
        <div class="datacell">使用率</div>
        <div class="datacell">逾期次数</div>
        <div class="datacell">发放日期</div>
        <div class="datacell">状态</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail.creditCardDetails">
        <div class="datacell">{{ item.bank_name }}</div>
        <div class="datacell">{{ item.grant_amount }}</div>
        <div class="datacell">{{ item.balance_amount }}</div>
        <div class="datacell">{{ item.usage_rate | formatParseInt }}%</div>
        <div class="datacell">{{ item.overdue_num ? item.overdue_num : 0 }}</div>
        <div class="datacell">{{ item.grant_date ? item.grant_date : '' }}</div>
        <div class="datacell">{{ item.current_status ? item.current_status : '' }}</div>
      </div>
    </div>

    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">相关还款责任信息</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">银行</div>
        <div class="datacell">责任金额</div>
        <div class="datacell">余额</div>
        <div class="datacell">担保对象</div>
        <div class="datacell">身份</div>
        <div class="datacell">状态</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail.relatedRepaymentDuty">
        <div class="datacell">{{ item.bank_name }}</div>
        <div class="datacell">{{ item.grant_amount }}</div>
        <div class="datacell">{{ item.balance_amount }}</div>
        <div class="datacell">{{ item.surety_name ? item.surety_name : "" }}</div>
        <div class="datacell">{{ item.guarantee_identity ? item.guarantee_identity : '' }}</div>
        <div class="datacell">{{ item.current_status ? item.current_status : '' }}</div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    detail: {
      type: Object
    },
  }
}
</script>

<style></style>